export enum DataDictionaryType {
    activity,
    behavior,
    case,
    user,
    subTask,
    task,
    all,
    master,
   
}

export class DataDictionaryTypeUtil {

    public static toString(type: DataDictionaryType): string {
        let value = 'Unknown';

        switch (type) {
            case DataDictionaryType.activity:
                value = 'activity';
                break;
            case DataDictionaryType.case:
                value = 'case';
                break;
            case DataDictionaryType.user:
                value = 'user';
                break;
            case DataDictionaryType.subTask:
                value = 'subtask';
                break;
            case DataDictionaryType.task:
                value = 'task';
                break;
            case DataDictionaryType.behavior:
                value = 'behavior';
                break;
             case DataDictionaryType.master:
                value = 'master';
                break;
        }

        return value;
    }
}
